import type { AxiosRequestConfig } from "axios";

/**
 * Lee el token del usuario. Se mantiene el JSON.parse sobre el valor crudo: si no hay
 * usuario en localStorage, el original ya lanzaba al desestructurar sobre null, y este
 * modulo conserva ese comportamiento en vez de inventarle un fallback.
 */
const readToken = (): string | undefined => {
    const { token } = JSON.parse(localStorage.getItem("user") as string) as { token?: string };
    return token;
};

const Config = (): AxiosRequestConfig | undefined => {
    const token = readToken();
    const language = localStorage.getItem("language");
    if (token !== "") {
        if (token !== undefined) {
            return {
                headers: {
                    Authorization: `Bearer ${token.replaceAll("\"", "")}`,
                    "Accept-Language" : language
                }
            }
        }

    } else {
        return {
            headers: {}
        }
    }

}
const ConfigParams = (paramsBenefits: string[]): AxiosRequestConfig | undefined => {
    const token = readToken();
    if (token !== "") {
        if (token !== undefined) {
           // El original comparaba el array contra "" con != , apoyandose en la coercion
           // a string. String(x) !== "" reproduce esa semantica exacta, incluido el caso
           // [""] (que daba falso) y null/undefined (que daban verdadero).
           if (String(paramsBenefits) !== "") {
            return {
                headers: {
                    Authorization: `Bearer ${token.replaceAll("\"", "")}`,
                },
                params: {
                    benefits: paramsBenefits.join(',')
                }
            }
           } else {
            return {
                headers: {
                    Authorization: `Bearer ${token.replaceAll("\"", "")}`,
                },
            }
           }
        }

    } else {
        return {
            headers: {}
        }
    }

}

const ConfigHeaderBlobResponse = (): AxiosRequestConfig | undefined => {
    const token = readToken();
    const language = localStorage.getItem("language");
    if (token !== "") {
        if (token !== undefined) {
            return {
                headers: {
                    Authorization: `Bearer ${token.replaceAll("\"", "")}`,
                    "Accept-Language" : language
                },
                responseType: "blob"
            }
        }
    } else {
        return {
            headers: {}
        }
    }
}

const BeareToken = (): string | undefined => {
    const token = readToken();
    if (token !== "") {
        if (token !== undefined) {
            return `Bearer ${token.replaceAll("\"", "")}`
        }
    } else {
        return ''
    }
}

export {Config,ConfigParams, ConfigHeaderBlobResponse, BeareToken}
